import { Avatar, Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTokenContext } from "../../auth/UserTokenProvider";
import SpotifyLogoRoundImage from "../../img/spotify-logo-round.png";

const Welcome: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { token } = useTokenContext();

  // Note: Session cookie is httpOnly in production, so JavaScript cannot read it
  // This is a security feature to prevent XSS attacks
  // The cookie is still sent automatically with all requests

  // Auto-navigate if we have a valid token
  useEffect(() => {
    if (token && token.value) {
      console.log("Valid token found, navigating to lyrics view");
      navigate("/");
    }
  }, [token, navigate]);

  const onLoginButtonClicked = () => {
    navigate("/spotify-authorization");
  };

  return (
    <Box textAlign="center">
      <Typography variant="h4" gutterBottom>
        Spotify Panel
      </Typography>

      <Typography gutterBottom>
        To get access to your current playing song, you need to sign into Spotify.
      </Typography>

      {/* Debug Information */}
      <Box
        sx={{
          mt: 2,
          p: 2,
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          textAlign: "left"
        }}
      >
        <Typography variant="body2" color="text.secondary">
          <strong>Session Status:</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Authenticated: {token ? "Yes" : "No"}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Token Expires: {token?.expiry ? token.expiry.toLocaleString() : "N/A"}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.75rem", mt: 1 }}>
          Note: Session cookie is secure and httpOnly (hidden from JavaScript for security)
        </Typography>
      </Box>

      <Button
        variant="outlined"
        color="primary"
        onClick={onLoginButtonClicked}
        startIcon={
          <Avatar
            src={SpotifyLogoRoundImage}
            alt="Spotify Logo Round"
            style={{ width: 20, height: 20 }}
          />
        }
        sx={{ mt: 2 }}
      >
        Sign In With Spotify
      </Button>
    </Box>
  );
};

export default Welcome;
